import InsuranceSuiteMetadata from './InsuranceSuiteMetadataService';
import 'l10nModule';

/**
 * Module provides API to work with DTO metadata.
 */

export default angular.module('gw-portals-metadata-angular', ['edge.platform.l10n']).factory('InsuranceSuiteMetadata', InsuranceSuiteMetadata);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-metadata-angular/module.js
// module id = 318
// module chunks = 0